import { render, staticRenderFns } from "./ScoreDisplay.vue?vue&type=template&id=45d77915&scoped=true&"
import script from "./ScoreDisplay.vue?vue&type=script&lang=js&"
export * from "./ScoreDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d77915",
  null
  
)

export default component.exports